module.exports = __webpack_public_path__ + "source-code-pro-v11-latin-regular.woff2?982234eca7d717dd9784d15519ece2f8";